import React from 'react';
import Routes from './Routes';
import Helmet from 'react-helmet';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

import { minutesToMs } from 'helpers';
import { getAdminNotifications } from './actions/adminNotifications';
import './normalize.css';
import './App.css';
import ErrorMessage from './Error';
import Footer from 'components/Footer';

class App extends React.Component {
	state = {
		hasError: false,
		adminNotificationsIntervalId: false,
	};

	componentDidCatch() {
		this.setState({
			hasError: true,
		});
	}

	componentDidMount() {
		this.startPolling();
	}

	componentWillUnmount() {
		this.stopPolling();
	}

	startPolling = () => {
		const { getAdminNotifications } = this.props;
		const adminNotificationOptions = {
			ignoreCache: true,
			filters: ['upcoming'],
		};

		getAdminNotifications(adminNotificationOptions);

		const adminNotificationsIntervalId = setInterval(
			() => getAdminNotifications(adminNotificationOptions),
			minutesToMs(5)
		);

		this.setState({
			adminNotificationsIntervalId,
		});
	};

	stopPolling = () => {
		const { adminNotificationsIntervalId } = this.state;

		if (adminNotificationsIntervalId) {
			clearInterval(adminNotificationsIntervalId);
		}
	};

	render() {
		const { location } = this.props;
		const isLoginPage = location && location.pathname === '/login';

		return (
			<div className="app-shell">
				<Helmet titleTemplate="%s - Bromma Backyard" />

				<div className="app-content">
					{this.state.hasError ? <ErrorMessage /> : <Routes />}
				</div>

				{!isLoginPage && <Footer />}
			</div>
		);
	}
}

const mapState = state => ({
	auth: state.auth,
});

const mapDispatch = dispatch => ({
	getAdminNotifications: (...args) => dispatch(getAdminNotifications(...args)),
});

export default compose(withRouter, connect(mapState, mapDispatch))(App);



// WEBPACK FOOTER //
// ./src/App.js